import { MutableRefObject, useRef } from "react";


interface IuseWindowOpen {
  opened: MutableRefObject<Window | null>;

  open(url: string): Window | null;
}

export function useWindowOpen(): IuseWindowOpen {
  const currentWindow = useRef<Window | null>(null);

  return {
    opened: currentWindow,
    open(url: string): Window | null {
      const newWindow = window.open(url);
      if (!newWindow) {
        return null;
      }
      newWindow.opener = null;

      currentWindow.current = newWindow;

      return newWindow;
    }
  };
}